import { IState } from 'shared/store';

export const getNewbuildingId = (state: IState): string => {
  return state.offerData.offer.newbuilding.id;
};
